import { Component, OnInit, OnDestroy, AfterViewInit, Output, EventEmitter, ViewChild, HostListener } from '@angular/core'
import { ViewService, SelectorService, HttpService } from '../../shared'
import { Field, Type, ImageExtractor, TextExtractor, LinkExtractor, Filter } from '../../model/selector'
import { Collection, Paginator } from '../../model/collection'

declare var $: any;
let FileSaver = require('file-saver');

@Component({
	selector: 'selector-list',
	template: require('./list.component.html'),
	styles: [require('./list.component.scss'), require('../../app.component.scss')],
	host: {
		'(window:message)': 'eventListener($event)',
		'(window:popstate)': 'onPopState($event)'
	}
})

export class SelectorListComponent implements OnInit, OnDestroy {

	selectorList: Field[];
	collectionList: Collection[];

	private click = new Event('click');

	private enable_add_collection = false;
	private details_parent_stack: Array<Collection> = new Array<Collection>();
	private selectedItem: any = null;

	private details_mode = false;

	private paginator_selecting = false;

	current_collection: Collection = null;

	private isImport = false;

	// old stuff
	private selectedId = -1;
	private oldSelector = null;
	selectedSelector = {};

	@Output() collectionChanged = new EventEmitter();
	@Output() formatChanged = new EventEmitter();

	constructor(private selectorService: SelectorService, private httpService: HttpService, private viewService: ViewService) {

	}

	ngOnInit() {
		this.collectionList = this.selectorService.getCollections();
		if (window.history.state !== null) {
			$.extend(this.current_collection, window.history.state);
			if (this.current_collection) {
				this.collectionChanged.emit({ url: this.current_collection.request.url, name: this.current_collection.name });
			}
		}
	}

	onSelect(selector, selectorId: number) {
		this.selectedItem = selector;
		this.selectedId = selectorId;
		/* if (selector.type === Type.Text && selector.extractor.params.regexp.length > 0) {
			this.selectedItem.count = this.selectorService.setSelectorPath(selector.selector, selector.extractor.params.regexp);
		} else {
			this.selectedItem.count = this.selectorService.setSelectorPath(selector.selector);
		} */
		this.selectorService.setSelectorPath(selector);
	}

	reset() {
		this.current_collection = null;
	}

	onListBlur(event) {
		if (!this.viewService.isSelecting) {
			this.selectedItem = null;
			this.selectorService.resetSelection();
			this.selectedId = -1;
		}
	}

	onAddSelector() {
		if (!this.viewService.isSelecting) {
			this.viewService.activateWebTab();
			this.selectorService.enableSelectorGadget();
			this.viewService.isSelecting = true;

			this.selectedId = this.current_collection.fields.push(new Field('Click on element to select it', '', null));
			this.selectedItem = this.current_collection.fields[--this.selectedId];
			this.selectorService.info = `
				Click on the first element on the page to be matched by selector. It will be highlighted in <span style="background-color:#22FF07;">Green.</span>
				Dataflow Kit will suggest similar elements that you may also want to select and mark them in <span style="background-color:#FFFF44;">Yellow.</span>
				Click \' <i class="fa fa-check" aria-hidden="true"></i> Apply \' when you'll finish.
			`;
		} else {
			this.viewService.isSelecting = false;
			this.selectorService.disableSelectorGadget();
			this.selectorService.info = 'Click \' <i class="fa fa-plus" aria-hidden="true"></i> Add new selector \' to start select extracting data';
			if (this.current_collection.fields[this.current_collection.fields.length - 1].selector === '') {
				this.current_collection.fields.splice(this.current_collection.fields.length - 1, 1);
			} else {
				if (this.current_collection.name === 'Collection') {
					this.selectorService.initCollection(this.current_collection, this.httpService.current_url, this.httpService.proxy);
				}
			}
			this.selectedId = -1;
			window.history.pushState({ key: 'collection', value: this.current_collection }, document.title, '');
		}
	}

	onEditCSS(selectorId: number): void {
		this.viewService.activateWebTab();
		this.selectorService.enableSelectorGadget();
		this.viewService.isSelecting = true;
		this.selectedId = selectorId;
		this.oldSelector = Object.assign({}, this.current_collection.fields[this.selectedId]);
		this.oldSelector.__proto__ = Field.prototype;
		// this.oldSelector = this.current_collection.fields[this.selectedId];
	}

	onAddCollection() {
		this.viewService.activateWebTab();
		this.viewService.enableUI = true;
		this.selectorService.info = 'Click \' <i class="fa fa-plus" aria-hidden="true"></i> Add new selector \' to start select extracting data';
		this.current_collection = this.selectorService.addNewCollection('Collection', '');
	}

	onSelChange(collection: Collection) {
		/*if (this.details_mode === true) {
			this.details_mode = false;
		}*/
		let have2Update = false;
		if (this.current_collection != null && this.current_collection.request.url === '') {
			this.onDeleteCollection();
		}
		this.httpService.proxy = collection.request.proxy;
		if (this.httpService.current_url !== collection.request.url) {
			this.viewService.enableUI = false;
			this.collectionChanged.emit({ url: collection.request.url, name: collection.name });
		} else {
			have2Update = true;
		}
		this.current_collection = collection;
		if (have2Update) {
			this.updateSelectorsCount();
		}
	}

	resetDetailsHistory() {
		this.details_mode = false;
		this.details_parent_stack.length = 0;
	}

	onAddDetails(details: Collection) {
		this.details_mode = true;
		this.details_parent_stack.push(this.current_collection);

		this.current_collection = details;
		this.selectorList = details.fields;
		this.collectionChanged.emit({ url: details.request.url });
		this.viewService.enableUI = false;
	}

	onDeleteSelector(selector_id: number) {
		if (!this.viewService.isSelecting) {
			this.current_collection.deleteSelector(selector_id);
		}
	}

	onCancel() {
		if (this.selectedId !== -1 && (this.current_collection.fields[this.selectedId].type === Type.Dump ||
			this.oldSelector == null)) {
			this.current_collection.deleteSelector(this.selectedId);
			this.selectedId = -1;
		} else if (this.oldSelector == null) {
			this.current_collection.paginatorUI = null;
		}
		if (this.selectedId >= 0 && this.oldSelector !== null) {
			this.current_collection.fields[this.selectedId] = this.oldSelector;
			this.oldSelector = null;
		}
		this.selectedId = -1;
		this.viewService.isSelecting = false;
		this.selectorService.disableSelectorGadget();
		this.selectorService.info = 'Click \' <i class="fa fa-plus" aria-hidden="true"></i> Add new selector \' to start select extracting data';
	}

	onDone() {
	}

	onBack() {
		this.current_collection = this.details_parent_stack.pop();
		this.onSelChange(this.current_collection);
		if (this.details_parent_stack.length === 0) {
			this.details_mode = false;
		}
	}

	onDeleteCollection() {
		if (!this.details_mode) {
			this.selectorService.deleteCollection(this.current_collection.name);
			if (this.selectorService.getCollections().length > 0) {
				this.current_collection = this.selectorService.getCollections()[0];
			} else {
				this.current_collection = null;
			}
			this.viewService.activateWebTab();
		} else {
			let parentCollection = this.details_parent_stack.pop();
			for (let selector of parentCollection.fields) {
				if (selector.details === this.current_collection) {
					selector.details = null;
					this.onSelChange(parentCollection);
				}
			}
		}
	}

	onAddPaginator(type: string) {
		this.viewService.activateWebTab();
		this.current_collection.paginatorUI = new Paginator();
		/* this.current_collection.paginator.maxPages = 10; */
		this.current_collection.paginatorUI.type = type;
		if (type === 'next') {
			this.viewService.isSelecting = true;
			this.selectorService.enableSelectorGadget();
			this.current_collection.paginatorUI.attr = 'href';
			this.current_collection.request.type = '';
		} else {
			this.current_collection.request.type = 'chrome';
			this.current_collection.request.actions.push({
				'scroll': {
					'paginate': 10,
					'element': ''
				}
			});
			// = '[{"paginate":{"maxpage":10, "element":""}}]';
			if (type === 'more') {
				this.viewService.isSelecting = true;
				this.selectorService.enableSelectorGadget();
			}
		}
		if (type !== 'infinite') {
			this.selectedItem = this.current_collection.paginatorUI;
		}
	}

	onDeletePaginator() {
		this.current_collection.paginatorUI = null;
		this.current_collection.request.type = '';
		this.current_collection.request.actions = [];
		this.current_collection.paginator = '';
	}

	onSelectorItemClick(selector: Field) {
		this.selectedSelector = selector;
		this.selectorService.setSelectorPath(selector);
	}

	ngOnDestroy() {
		// this.selectorService.resumeGadget();
	}

	eventListener(event: any) {
		console.log(event);
		if (event.data.event_id === 'scripts_loaded') {
			this.viewService.enableUI = true;
			if (this.current_collection == null) {
				this.onAddCollection();
			} else {
				let existCollection: Collection = this.selectorService.getCollectionByUrl(this.httpService.current_url);
				if (existCollection !== null) {
					if (existCollection.request.url !== this.current_collection.request.url) {
						if (this.current_collection.request.url === '') {
							this.onDeleteCollection();
						}
						this.current_collection = existCollection;
					} else {
						// during import process we have to manualy update selector's count field
						this.updateSelectorsCount();
					}
				} else {
					if (this.current_collection.request.url !== '' && !this.details_mode && !this.isImport) {
						this.onAddCollection();
					} else {
						this.isImport = false;
						this.updateSelectorsCount();
					}
				}
			}
		}
		if (event.data.event_id === 'selection_changed') {
			if (this.selectedItem.name === undefined) {
				if (this.current_collection.paginatorUI.type === 'next') {
					this.current_collection.paginatorUI.selector = event.data.data.current_selected;
					this.current_collection.paginator = event.data.data.current_selected;
				} else {
					this.current_collection.paginatorUI.selector = event.data.data.current_selected;
					let paginator_action = null;
					for (let i = 0; i < this.current_collection.request.actions.length; i++) {
						paginator_action = this.current_collection.request.actions[i]
						if ('scroll' in paginator_action) {
							paginator_action.scroll.element = event.data.data.current_selected;
							break;
						}
					}
					/* this.current_collection.request.actions.push({
						'scroll': {
							'paginate': 10,
							'element': event.data.data.current_selected
						}
					}) */
					/* this.current_collection.request.actions = '[{"paginate":{"maxpage":10, "element":"' +
					event.data.data.current_selected + '"}}]' */
				}
			} else {
				this.current_collection.updateSelection(this.selectedId, event);
			}
		}
		if (event.data.event_id === 'navigate') {
			// window.history.pushState({key: 'link', value: this.httpService.current_url}, document.title, '');
			this.collectionChanged.emit({ url: event.data.href, post_params: event.data.postData, action: event.data.action });
			this.viewService.enableUI = false;
		}
	}

	onPopState(event) {
		console.log(event.state);
		if (event.state !== null) {
			switch (event.state.key) {
				case 'collection':
					this.current_collection = <Collection>event.state.value;
					this.castFiledsToCorespondingSelectorType(this.current_collection.fields);
					break;
				case 'link':
					this.collectionChanged.emit({ url: event.state.value, post_params: '', func: '' });
					this.viewService.enableUI = false
					break;
			}
		}
	}

	onChangeFormat(format: string) {
		if (this.current_collection != null) {
			this.current_collection.format = format;
			this.formatChanged.emit();
		}
	}

	onExportCollection() {
		let blob = new Blob([this.current_collection.stringify(this.current_collection.format, this.current_collection.name)],
			{ type: 'text/plain;charset=utf-8' });
		FileSaver.saveAs(blob, this.current_collection.name + '.collection.json', { autoBom: true });
	}

	onImportCollection(files: FileList) {
		if (files.length > 1) {
			this.viewService.errorAlert('Multiple files not allowed.');
			return;
		}
		let reader = new FileReader();
		reader.onload = () => {
			let col = JSON.parse(<string>reader.result);
			col.__proto__ = Collection.prototype;
			if (!<Collection>col.isValid()) {
				this.viewService.errorAlert('Invalid collection file.');
				return;
			}
			this.castFiledsToCorespondingSelectorType(col.fields);
			this.importPaginator(col);
			this.onSelChange(col);
			this.selectorService.addCollection(col);
			this.isImport = true;
		}
		if (files[0].size > 512000) {
			this.viewService.errorAlert('Selected file is too large.');
			return;
		}
		reader.readAsText(files[0]);
	}

	onProxyChanged(event) {
		if (this.current_collection !== null && this.current_collection.request !== null && this.current_collection.request.url.length > 0) {
			this.current_collection.request.proxy = event.proxy;
		}
	}

	castFiledsToCorespondingSelectorType(arr: Array<any>) {
		for (let i = 0; i < arr.length; i++) {
			if (arr[i].details != null) {
				this.castFiledsToCorespondingSelectorType(arr[i].details.fields);
				arr[i].details.__proto__ = Collection.prototype;
				this.importPaginator(arr[i].details);
			}
			arr[i].__proto__ = Field.prototype;
			for (let f = 0; f < arr[i].filters.length; f++) {
				arr[i].filters[f].__proto__ = Filter.prototype;
			}
		}
	}

	importPaginator(col: Collection) {
		if (col.hasOwnProperty('paginator') && col.paginator !== null) {
			let paginator: any = col.paginator;
			col.paginatorUI = new Paginator();
			col.paginatorUI.selector = paginator.nextPageSelector;
			col.paginatorUI.attr = 'href';
			col.paginatorUI.type = 'next';
			col.paginatorUI.pageNum = paginator.pageNum;
		} else if (col.request.hasOwnProperty('actions') && col.request.actions.length > 0) {
			for (let i = 0; i < col.request.actions.length; i++) {
				if (col.request.actions[i].hasOwnProperty('scroll')) {
					col.paginatorUI = new Paginator();
					col.paginatorUI.attr = 'href';
					let pag = col.request.actions[i].scroll;
					if (pag.hasOwnProperty('element') && pag.element !== '') {
						col.paginatorUI.selector = pag.element;
						col.paginatorUI.type = 'more';
					} else {
						col.paginatorUI.type = 'infinite';
					}
					if (!pag.hasOwnProperty('paginate')) {
						// default value
						col.paginatorUI.pageNum = 10;
					} else {
						col.paginatorUI.pageNum = pag.paginate;
					}
				}
			}
			/*let pagArr = JSON.parse(col.request.actions);
			 if (pagArr instanceof Array && 'paginate' in pagArr[0]) {
				col.paginatorUI = new Paginator();
				col.paginatorUI.attr = 'href';
				let pag = pagArr[0];
				if ('element' in pag.paginate && pag.paginate.element !== '') {
					col.paginatorUI.selector = pag.paginate.element;
					col.paginatorUI.type = 'more';
				} else {
					col.paginatorUI.type = 'infinite';
				}
			} */
		}
	}

	updateSelectorsCount() {
		for (let idx = 0; idx < this.current_collection.fields.length; idx++) {
			this.current_collection.fields[idx].count = this.selectorService.getCount(this.current_collection.fields[idx].selector);
		}
	}
}
